import { Form } from '@homex/se-react-components';
import styled from 'styled-components/macro';

import { ReactComponent as HvacBrokenSvg } from 'components/svg/HvacBroken.svg';
import { containerTall } from 'styles/layout';

export const FormGroup = styled(Form)`
  ${containerTall}
`;

export const HvacBrokenStyled = styled(HvacBrokenSvg)`
  height: 132px;
  margin: 46px -21px 21px 0;
  width: 160px;
`;
